export default "__VITE_ASSET__4423fdfe__"